export default "__VITE_ASSET__BwudGAAY__ 480w, __VITE_ASSET__BDupofIH__ 768w, __VITE_ASSET__DLPRpNhF__ 1200w, __VITE_ASSET__DCzAoYhI__ 1920w";